import { render } from "./ReminderMessageAddPage.vue?vue&type=template&id=541706ba&scoped=true"
import script from "./ReminderMessageAddPage.vue?vue&type=script&lang=js"
export * from "./ReminderMessageAddPage.vue?vue&type=script&lang=js"

import "./ReminderMessageAddPage.vue?vue&type=style&index=0&id=541706ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541706ba"]])

export default __exports__